import { Flex, TextV2, Box } from '@withjoy/joykit';
import { Close } from '@withjoy/joykit/icons';
import React from 'react';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';
import { LocationDatesOccupants } from '@apps/accommodations/components/LocationDatesOccupantsSearchBar/LocationDatesOccupantsSearchBar';
import { getSearchFormInitialValue } from '@apps/accommodations/AccommodationsConsole.utils';
import { AccommodationsConsoleState } from '@apps/accommodations/AccommodationsConsole.types';
import { StaysSearchTerms } from '@apps/stays/types';

export const MobileSearchComponent = ({
  onClose,
  state,
  handleFormSubmit,
}: {
  onClose: () => void;
  state: AccommodationsConsoleState;
  handleFormSubmit: (value: StaysSearchTerms) => void;
}) => {
  const { t } = useTranslation('accommodationsConsole');
  const mobileSearchTrans = t('mobileSearch');
  const initialValue = getSearchFormInitialValue(state);

  return (
    <>
      <Box
        padding={pxToRem(24)}
        height={'97%'}
      >
        <DrawerHeader
          title={mobileSearchTrans.title()}
          onClose={onClose}
        />
        <Box
          width={'100%'}
          paddingTop={4}
          height={'100%'}
        >
          <LocationDatesOccupants
            onSubmit={values => {
              onClose();
              handleFormSubmit(values);
            }}
            initialValue={initialValue}
          />
        </Box>
      </Box>
    </>
  );
};

const DrawerHeader = ({ title, onClose }: { title: string; onClose: () => void }) => {
  return (
    <Flex justifyContent={'space-between'}>
      <TextV2 typographyVariant="hed3">{title}</TextV2>
      <Close onClick={onClose} />
    </Flex>
  );
};
